import { useMemo } from 'react';

import { useDeletePeer } from '@givebacks/api/store';

import { useShowCampaignSettings } from '../../../../api/new/campaigns/utils/campaignUtils';
import { participantColumns, teamColumns } from '../Campaigns/Settings/Peers/PeerColumns';
import { usePeerName } from './usePeerName';

// Create a hook that returns multiple different hooks based on the currently selected peer_type from the params
export const useCampaignPeers = () => {
  const { peerName, peer_type } = usePeerName();

  const { data: campaignSettings } = useShowCampaignSettings();
  const { isTeamsEnabled } = campaignSettings;

  const participantColumnsToRender = useMemo(() => {
    const participantColumnsWithoutTeam = participantColumns.filter(
      (col) => col.id !== 'team.name'
    );
    if (isTeamsEnabled) {
      return participantColumns;
    } else {
      return participantColumnsWithoutTeam;
    }
  }, [isTeamsEnabled]);

  const peerColumns = useMemo(() => {
    if (peer_type === 'teams') {
      return teamColumns;
    } else {
      return participantColumnsToRender;
    }
  }, [peer_type, participantColumnsToRender]);

  return {
    peer_type,
    peerColumns,
    peerName,

    useDeletePeer,
  };
};
